import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { repeat as c } from '../../../../node_modules/lit-html/directives/repeat.js';
import './toast-notification.js';
import css_248z from './toast-region.scss.js';

const MAX_VISIBLE_DEPTH = 3;
let nextToastId = 0;
class ToastRegion extends s {
    constructor() {
        super(...arguments);
        this.toasts = [];
        this.statusText = '';
        this.alertText = '';
        this.announcement = '';
    }
    show(options) {
        nextToastId += 1;
        const toast = Object.assign(Object.assign({}, options), { id: nextToastId });
        this.toasts = [...this.toasts, toast];
        this.announceToast(toast).catch(() => undefined);
        return toast.id;
    }
    dismiss(id) {
        this.toasts = this.toasts.filter(toast => toast.id !== id);
    }
    async announce(text) {
        this.announcement = '';
        await this.updateComplete;
        this.announcement = text;
    }
    async announceToast(toast) {
        const text = [toast.title, toast.message].filter(Boolean).join('. ');
        this.statusText = '';
        this.alertText = '';
        await this.updateComplete;
        if (toast.variant === 'error') {
            this.alertText = text;
        }
        else {
            this.statusText = text;
        }
    }
    static depthStyle(depth) {
        const d = Math.min(depth, MAX_VISIBLE_DEPTH);
        const opacity = depth > MAX_VISIBLE_DEPTH ? 0 : 1 - d * 0.15;
        return `transform: translateY(${-d * 10}px) scale(${1 - d * 0.05}); opacity: ${opacity}; z-index: ${100 - depth}`;
    }
    renderToast(toast, index) {
        var _a, _b;
        const depth = this.toasts.length - 1 - index;
        const isBehind = depth > 0;
        return $ `<div class="slot ${isBehind ? 'is-behind' : ''}" style="${ToastRegion.depthStyle(depth)}" ?inert="${isBehind}" aria-hidden="${isBehind ? 'true' : 'false'}"><toast-notification .variant="${toast.variant}" .heading="${toast.title}" .message="${(_a = toast.message) !== null && _a !== void 0 ? _a : ''}" .durationMs="${toast.durationMs}" .closeLabel="${(_b = toast.closeLabel) !== null && _b !== void 0 ? _b : 'Close notification'}" @toast-dismiss="${() => this.dismiss(toast.id)}"></toast-notification></div>`;
    }
    render() {
        return $ `<div class="announcer"><div role="status">${this.statusText}</div><div role="alert">${this.alertText}</div><div role="status">${this.announcement}</div></div><div class="stack"><div class="stack-inner">${c(this.toasts, toast => toast.id, (toast, index) => this.renderToast(toast, index))}</div></div>`;
    }
}
ToastRegion.styles = css_248z;
__decorate([
    t()
], ToastRegion.prototype, "toasts", void 0);
__decorate([
    t()
], ToastRegion.prototype, "statusText", void 0);
__decorate([
    t()
], ToastRegion.prototype, "alertText", void 0);
__decorate([
    t()
], ToastRegion.prototype, "announcement", void 0);
customElements.define('toast-region', ToastRegion);

export { ToastRegion };
